//
import SmoothScroll from 'smooth-scroll';
import 'sticky-kit/dist/sticky-kit.js';
import 'bootstrap-slider';
import 'parsleyjs';
import Inputmask from "inputmask";
import 'slick-carousel';
import 'select2';
import 'daterangepicker';

var moneyFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

var scroll = new SmoothScroll('a[data-scroll]', {
    speed: 1200
});

var screen = 992;
var windowHeight, windowWidth;

function activeStickyKit() {
    $('[data-sticky_column]').stick_in_parent({
        parent: '[data-sticky_parent]',
        offset_top: 20
    });

    // bootstrap col position
    // $('[data-sticky_column]')
    // 	.on('sticky_kit:bottom', function (e) {
    // 		$(this).parent().css('position', 'static');
    // 	})
    // 	.on('sticky_kit:unbottom', function (e) {
    // 		$(this).parent().css('position', 'relative');
    // 	});
}
function calc_header(){
    // get total height for <header>, including padding
    var headerEl = document.getElementById("navbar-header");
    var headerHeight = +headerEl.offsetHeight;

    // set margin-top to <form> depending on <header> height
    //var formEl = document.getElementsByClassName("body-section");
    //formEl.style.marginTop = headerHeight  + 'px';
    $('.wrapper-steps').css('margin-top',headerHeight  + 'px');
}
function detachStickyKit() {
    $('[data-sticky_column]').trigger("sticky_kit:detach");
}

// windowSize
// window resize
function windowSize() {
    windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
    windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

window.formatDate = function (date, format = process.env.MIX_DATE_FORMAT) {
    return moment(date, [process.env.MIX_DATE_FORMAT, "YYYY-MM-DD"]).format(format);
}

window.formatMoney = function (number) {
    return moneyFormatter.format(number);
}

window.formatICNumber = function (ic_number) {
    return _.replace(ic_number, new RegExp('-', 'g'), '');
}

window.Parsley.addValidator('ageBetweenByIc', {
    requirementType: ['integer', 'integer'],
    validateString: function(value, min_age, max_age) {
        let year = value.substr(0, 2);
        let month = value.substr(2, 2);
        let date = value.substr(4, 2);

        if(parseInt(year) >= 35) {
            year = "19"+year;
        } else {
            year = "20"+year;
        }

        let age = moment().diff(year + '-' + month + '-' + date, 'years');

        return (age >= min_age && age <= max_age );
    },
    messages: {
        en: 'The age eligibility is %s to %s years old'
    }
});

$(function () {
    calc_header();

    new Inputmask().mask('[data-inputmask-mask]');

    $('[data-toggle="tooltip"]').tooltip({
        container: 'body',
        boundary: 'window'
    });

    // $('select').selectpicker();
    $('[data-select]').select2({
        width: '100%',
        theme: 'bootstrap4',
    }).on('select2:select', function (e) {
        $(this).parsley().validate();
    });

    $('[data-daterangepicker]').each(function () {
        let singleDatePicker = $(this).data('singledatepicker');
        let minDate = $(this).data('mindate');
        let maxDate = $(this).data('maxdate');
        let option = {};

        if (singleDatePicker !== undefined) {
            option.singleDatePicker = true;
            option.showDropdowns = true;
        }

        if (minDate) {
            option.minDate = formatDate(minDate);
        }

        if (maxDate) {
            option.maxDate = formatDate(maxDate);
        }

        $(this).daterangepicker({
            ...option,
            autoUpdateInput: false,
            locale: {
                format: process.env.MIX_DATE_FORMAT
            }
        });
    });

    // need to manually update the input value if want to initial empty dates
    $('[data-daterangepicker]').on('apply.daterangepicker', function (ev, picker) {
        let singleDatePicker = $(this).data('singledatepicker');

        if (singleDatePicker !== undefined) {
            $(this).val(picker.startDate.format(process.env.MIX_DATE_FORMAT)).trigger('change');
        } else {
            $(this).val(picker.startDate.format(process.env.MIX_DATE_FORMAT) + ' - ' + picker.endDate.format(process.env.MIX_DATE_FORMAT)).trigger('change');
        }

        $(this).parsley().validate();
    });

    $('[data-toggle="popover"]').popover();

    if ($('[data-sticky_column]').length) {
        //  stop sticky kit
        //  based on your window width
        windowWidth = $(window).width();
        if ((windowWidth < screen)) {
            detachStickyKit();
        } else {
            activeStickyKit();
        }

        $(window).resize(debounce(function () {
            windowSize();
            $(document.body).trigger("sticky_kit:recalc");
            if (windowWidth < screen) {
                detachStickyKit();
            } else {
                activeStickyKit();
            }
        }, 250));
    }

    $('form').on('keyup', '.uppercase', function () {
        $(this).val($(this).val().toUpperCase());
    }).on('change', '.uppercase', function () {
        $(this).val($(this).val().toUpperCase());
    });
});
$.fn.select2.defaults.set( "theme", "bootstrap4" );

/* 1. Preloder */
$(window).on("load", function() {
    $('#preloader-active').delay(450).fadeOut('slow');
    $('body').delay(450).css({
        'overflow': 'visible'
    });
});

//parsley
$(document).ready(function() {
    // bind Parsley to the form
    $("form").parsley();

    // Whenever parsley validates successfully, we enable the submit button
    window.Parsley.on('form:success', function(ParsleyForm) {
        ParsleyForm.$element.find('button').prop('disabled', false);
    });

    // When a validation error occurs, we disable the submit button
    window.Parsley.on('form:error', function(ParsleyForm) {
        ParsleyForm.$element.find('button').prop('disabled', false);
    });

});

jQuery(document).ready(function(){

    //==================================================
    // Header ads
    jQuery('.closeads').click(function(){
        $.when(jQuery(this).parent('.navbar-ads').slideUp()).then(function(){
            calc_header();
        })
    });

    //==================================================
    // navigation menu

    jQuery('.navbar-toggler').click(function(){
        if (jQuery(".collapse").is(":visible")) {
            jQuery("body, html").removeClass('overflow-hidden');
            jQuery(".menu-background").fadeOut();
        } else {
            // jQuery("body, html").addClass('overflow-hidden');
            setTimeout( function () {
                jQuery(".menu-background").fadeIn();
            }, 500);
        }
    });

    jQuery('.menu-background').click(function(){
        jQuery('.navbar-toggler').trigger( "click" );
    });

    //==================================================
    // Homepage: Vehicle Quotation Uppercase

    jQuery('.uppercase').keyup(function(){
        jQuery(this).val(jQuery(this).val().toUpperCase());
    });



    jQuery('.selection-productType input').click(function() {
        jQuery('.selection-productType').removeClass('selected').addClass('unselected');
        jQuery(this).parent('.selection-productType').removeClass('unselected').addClass('selected');
    });

    //==================================================
    // Homepage: Carousel

    // jQuery('.variable-width').slick({
    //     arrows: false,
    //     dots: false,
    //     infinite: true,
    //     speed: 6000,
    //     slidesToShow: 1,
    //     autoplay: true,
    //     autoplaySpeed: 0,
    //     cssEase: "linear",
    //     focusOnSelect: false,
    //     useTransform: false,
    //     variableWidth: true
    // });


    //==================================================
    // Range Slider

    jQuery("#sliderSumInsured").slider({
        tooltip: 'always'
    });

    //==================================================
    // tooltip

    //jQuery('[data-toggle="tooltip"]').tooltip();

    //==================================================
    // Steps hide on MD and click slideToggle

    jQuery('.progress_button').click(function() {
        jQuery('.header_steps').slideToggle();
        jQuery(this).children('span').toggleClass('slideUp');
    });


    //==================================================
    // Step 2

    //==================================================
    // loading Spinner

    // jQuery(window).on('load', function(){
    //     setTimeout(removeLoader, 2000); //wait for page load PLUS two seconds.
    // });
    function removeLoader(){
        jQuery(".compare_quote .price-compare_item .spinner-border").fadeOut(500, function() {
            var parent = jQuery(this).parent(".price-compare_item");
            var dataPrice = parent.attr("data-price");
            // fadeOut complete. Remove the loading div
            jQuery(this).remove(); //makes page more lightweight
            parent.text(dataPrice);
        });
    }




    //==================================================
    // Clone Recipient Name, Phone and Addresses
    jQuery('#recipientsameaddress').change(function() {
        if (jQuery(this).is(':checked')) {
            jQuery('#recipientname').val(jQuery('#name').val());
            jQuery('#recipientunit_no').val(jQuery('#name').val());
            jQuery('#recipientunit_no').val(jQuery('#unit_no').val());
            jQuery('#recipientbuilding_name').val(jQuery('#building_name').val());
            jQuery('#recipientaddress_one').val(jQuery('#address_one').val());
            jQuery('#recipientaddress_two').val(jQuery('#address_two').val());
            jQuery('#recipientaddress_city').val(jQuery('#city').val());
            jQuery('#recipientaddress_postcode').val(jQuery('#postcode').val());
        } else {
            jQuery('#recipientname').val('');
            jQuery('#recipientunit_no').val('');
            jQuery('#recipientunit_no').val('');
            jQuery('#recipientbuilding_name').val('');
            jQuery('#recipientaddress_one').val('');
            jQuery('#recipientaddress_two').val('');
            jQuery('#recipientaddress_city').val('');
            jQuery('#recipientaddress_postcode').val('');
        }
    });


});

//==================================================
// Modal Popup
jQuery(window).on('load', function() {
    jQuery('.lazyload').modal('show');
});
